import { render, staticRenderFns } from "./SkillsForm.vue?vue&type=template&id=b354ab98"
import script from "./SkillsForm.vue?vue&type=script&lang=js"
export * from "./SkillsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports